var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rmr-toggle-card",class:( _obj = {
    'rmr-toggle-card--active': _vm.value,
    'rmr-toggle-card--disabled': _vm.disabled
  }, _obj[("rmr-toggle-card--size-" + _vm.size)] = true, _obj ),on:{"click":_vm.onToggle}},[_c('v-checkbox',{staticClass:"rmr-checkbox mt-0 pt-0",attrs:{"input-value":_vm.value,"label":_vm.label,"disabled":_vm.disabled,"dense":"","hide-details":""},on:{"click":function($event){$event.stopPropagation();},"change":function($event){return _vm.$emit('input', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }